<template>
    <section>
        <h1 class="mb-0 mt-5 mb-3 text-center">Students</h1>

        <v-row>
            <v-col cols="8">
                <v-text-field
                        v-model="keyword"
                        label="Search"
                        hide-details
                >
                    <template v-slot:prepend-inner>
                        <svg v-svg="'icon-search'" size="15"></svg>
                    </template>
                </v-text-field>
            </v-col>

            <v-col cols="2">
                <v-select :items="[{team_name: 'All', team_id: 0}, ...users]"
                          label="Team"
                          item-text="team_name"
                          item-value="team_id"
                          v-model="team_id"
                          @change="getData()"
                >
                    <template v-slot:append>
                        <svg v-svg="'icon-select'" size="16"></svg>
                    </template>
                </v-select>
            </v-col>

            <v-col cols="2">
                <v-select :items="[{student_status: 'All', status_id: 0}, ...users]"
                          label="Status"
                          item-text="student_status"
                          item-value="status_id"
                          v-model="status_id"
                          @change="getData()"
                >
                    <template v-slot:append>
                        <svg v-svg="'icon-select'" size="16"></svg>
                    </template>
                </v-select>
            </v-col>
        </v-row>

        <div class="mt-2" :class="selected.length ? 'visible' : 'hidden'">
            <v-btn text @click="changeStatus(1)">
                <svg v-svg="'icon-in-progress'" size="20" class="mr-1"></svg>
                <span class="green--text text--lighten-1">In Progress</span>
            </v-btn>
            <v-btn text @click="changeStatus(3)">
                <svg v-svg="'icon-graduated'" size="20" class="mr-1"></svg>
                <span class="green--text">Graduated</span>
            </v-btn>
            <v-btn text @click="changeStatus(2)">
                <svg v-svg="'icon-left-out'" size="20" class="mr-1"></svg>
                <span class="orange--text text--darken-4">Left Out</span>
            </v-btn>
        </div>

        <v-data-table v-model="selected"
                      :headers="headers"
                      :items="users"
                      :page.sync="pagination.current"
                      :items-per-page="pagination.rowsPerPage"
                      show-select
                      hide-default-footer
                      class="elevation-1 mt-2 mb-6"
                      mobile-breakpoint="0"
        >
            <template v-slot:item.avatar="props">
                <v-avatar size="38">
                    <img :src="props.item.avatar || require('@/../public/images/Avatar.png')">
                </v-avatar>
            </template>

            <template v-slot:item.id="props">
                {{(pagination.current - 1)*pagination.rowsPerPage+props.index+1}}
            </template>

            <template v-slot:item.full_name="props">
                <router-link :to="{name : 'AdminStudentInfo', query: {student_id: props.item.id}}" class="text-decoration-none black--text">
                    {{props.item.full_name}}
                </router-link>
            </template>

            <template v-slot:item.status="props">
                <span class="font-weight-bold"
                      :class="{'green--text text--lighten-1': props.item.status_id === 1,
                               'orange--text text--darken-4': props.item.status_id === 2,
                               'green--text': props.item.status_id === 3}"
                >{{props.item.student_status}}</span>
            </template>
        </v-data-table>

        <div class="float-end mb-5">
            <v-pagination  v-model="pagination.current"
                           :length="pagination.total"
                           :total-visible="3"
                           color="green"
                           @input="getData"
            ></v-pagination>
        </div>

        <v-btn color="green" width="52" height="52" class="create" fab fixed bottom @click="$refs.create.dialog = true">
            <svg v-svg="'icon-create'" size="21"></svg>
        </v-btn>

        <create ref="create"></create>
    </section>
</template>

<script>
    import Create from '@/components/Admin/User/Create';
    export default {
        components: {
            Create,
        },

        data(){
            return {
                timeout: null,
                loadingRequest: false,
                team_id: this.$route.query.team_id,
                status_id: null,
                keyword: null,
                selected: [],
                headers: [
                    {text: 'Avatar', sortable: false, value: 'avatar', align: 'center'},
                    {text: '#ID', sortable: false, value: 'id'},
                    {text: 'Full Name', sortable: false, value: 'full_name'},
                    {text: 'Email', sortable: false, value: 'email'},
                    {text: 'Phone', sortable: false, value: 'phone'},
                    {text: 'Team', sortable: false, value: 'team_name'},
                    {text: 'Status', sortable: false, value: 'status'}
                ],
                users: [],
                pagination: {},
            }
        },

        watch: {
            keyword() {
                clearTimeout(this.timeout);
                this.timeout = setTimeout(() => {
                    this.getData(1);
                }, 300);
            }
        },

        mounted(){
            this.getData();
            this.getTeams();
        },

        methods: {
            getData(page){
                this.loadingRequest = true;
                this.$apiAdmin('users').get({params: {page: page, team_id: this.team_id, status_id: this.status_id, keyword: this.keyword}}).then((res) => {
                    const response = res.data.users;
                    this.pagination.rowsPerPage = response.per_page;
                    this.pagination.current = response.current_page;
                    this.pagination.total = response.last_page;
                    this.users = response.data;
                }).finally(() => {
                    this.loadingRequest = false;
                })
            },

            changeStatus(status_id){
                let selected_ids = this.selected.map(function(value){ return value.id })
                this.$apiAdmin('users').changeStatus({status_id: status_id, selected: selected_ids}).then(() => {
                    this.getData();
                    this.$store.dispatch('alert', {type: 1, message: 'Status Successfully Changed.'});
                    this.selected = [];
                });
            },

            getTeams(){
                this.$apiAdmin('teams').get({params: {all: 1}})
                    .then((res) => {
                        this.$store.commit('SET_TEAMS', res.data.teams);
                    })
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../../../scss/pages/tablePages";
    @import "../../../../scss/pages/Users/Students/students";
</style>